import { Pagination } from "../../../model/paginatiion";
import { IUsefulLinkResponse } from "../../../model/base/response/useful-links-response";
import { ICategoryLinkResponse } from "../../../model/base/response/category-link-response";

export interface IUsefulLinksState {
    usefulLinks: Pagination<IUsefulLinkResponse>;
    linkCategories: ICategoryLinkResponse[];
}

export const initialState: IUsefulLinksState = {
    usefulLinks: new Pagination<IUsefulLinkResponse>(),
    linkCategories: []
};

export enum ACTION_TYPES {
    SET_USEFUL_LINKS = 'SET_USEFUL_LINKS',
    SET_LINK_CATEGORIES = 'SET_LINK_CATEGORIES',
}

export interface IUsefulLinksAction {
    type: ACTION_TYPES;
    payload?: any;
}

export const usefulLinksReducer = (state: IUsefulLinksState, action: IUsefulLinksAction): IUsefulLinksState => {
    switch (action.type) {
        case ACTION_TYPES.SET_USEFUL_LINKS:
            return { ...state, usefulLinks: action.payload };
        case ACTION_TYPES.SET_LINK_CATEGORIES:
            return { ...state, linkCategories: action.payload };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
